import React, { Fragment, useState } from 'react';
import styled from 'styled-components/native';
import ListItem from '../../../../components/list/ListItem';
import ListItemIcon from '../../../../components/list/ListItemIcon';
import ListItemText from '../../../../components/list/ListItemText';
import Spacer from '../../../../components/Spacer';
import { H5 } from '../../../../components/Typography';
import Colors from '../../../../constants/Colors';
import StudyIntroModal from '../../../modals/StudyIntroModal';
import {
  ScreenComponentPlugin,
  ScreenComponentProps
} from '../ScreenComponentPlugin';

const StyledContainerView = styled.View`
  padding-top: 8px;
`;

const StyledRectangleImage = styled.Image`
  height: 43.29px;
  width: 49px;
  border-radius: 8px;
`;

interface StudyTemplateListDisplayItem {
  studyTemplateId?: number;
  title?: string;
  imageUrl?: string;
  description?: string;
}

interface StudyTemplateListProps {
  title?: string;
  studyTemplates?: StudyTemplateListDisplayItem[];
}

/** @deprecated */
const StudyTemplateList: React.FC<
  ScreenComponentProps<StudyTemplateListProps>
> = ({ title = 'List Title', studyTemplates = [] }) => {
  const [selectedStudyTemplateId, setSelectedStudyTemplateId] =
    useState<number>();
  const [selectedStudyTemplateTitle, setSelectedStudyTemplateTitle] =
    useState<string>();
  return (
    <StyledContainerView>
      <H5 color='dark'>{title}</H5>
      <Spacer size={2} />
      {studyTemplates.map((item, index) => (
        <Fragment key={index}>
          <ListItem
            framed
            divider
            filled
            onPress={() => {
              setSelectedStudyTemplateId(item.studyTemplateId);
              setSelectedStudyTemplateTitle(item.title);
            }}
          >
            <ListItemText
              primary={item.title || 'Study Name'}
              primaryTextColor={Colors.secondaryText}
              largeSecondary={item.description}
              secondaryTextColor={'#5B4FC2'}
            />
            <ListItemIcon iconPosition='right'>
              <StyledRectangleImage
                resizeMode='contain'
                source={{ uri: item.imageUrl }}
              />
            </ListItemIcon>
          </ListItem>
          <Spacer />
        </Fragment>
      ))}
      {/* {selectedStudyTemplateId && (
        <StudyIntroModal
          title={selectedStudyTemplateTitle}
          studyTemplateId={selectedStudyTemplateId}
          visible
          onClose={() => setSelectedStudyTemplateId(undefined)}
          onRequestClose={() => setSelectedStudyTemplateId(undefined)}
        />
      )} */}
    </StyledContainerView>
  );
};

/** @deprecated */
export const StudyTemplateListPlugin: ScreenComponentPlugin<StudyTemplateListProps> =
  {
    type: 'StudyTemplateList',
    name: 'Study Template List (deprecated)',
    categories: ['join'],
    component: StudyTemplateList
  };
